import { LitElement, html, css } from 'lit';

class MoreLikeThis extends LitElement {
  static properties = {
    uuid: { type: String, property: true },
    projects: { type: Array, state: true },
    error: { type: String, state: true },
    showCollectionButton: {
        type: Boolean,
        hasChanged(newVal, oldVal) {
            return newVal !== oldVal;
        },
        converter: {
            fromAttribute: (value, type) => {
                if (value === 'true' || value === 'True' || value == '1') {
                    return true;
                }
                return false;
            }
        }
    },
  };

  constructor() {
    super();
    this.uuid = '';
    this.projects = [];
    this.error = '';
    this.showCollectionButton = false;
  }

  firstUpdated() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadProjects();
          observer.unobserve(entry.target);
        }
      });
    }, options);

    observer.observe(this);
  }

  async loadProjects() {
    if (!this.uuid) return;

    try {
      const response = await fetch(`/project/${this.uuid}/mlt/`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      this.projects = data.projects || [];
    } catch (error) {
      console.error('Failed to load projects:', error);
      this.error = 'Failed to load projects: ' + error.message;
    }
  }

  static styles = css`
    .grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(min(230px, 100%), 1fr));
      grid-gap: 10px;
    }
    .project {
      display: block;
      text-align: center;
      box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.2);
      border:none;
      border-radius: var(--border-radius-base, 6px);
      background-color: var(--panel-bg-color, #141414);
    }
    .project img {
      border-top-left-radius: var(--border-radius-base, 6px);
      border-top-right-radius: var(--border-radius-base, 6px);
      width: 100%;
      height: auto;
    }
    .title {
      font-weight: bold;
      margin-top: 5px;
      padding: 0 0.25em;
      display: block;
    }
    .author {
      color: gray;
      font-size: 0.9em;
      display: block;
      margin-bottom: 1em;
    }
    
    a {
        color: var(--link-color, #A89368); 
        text-decoration: none;
    }
    
    a:visited {
        color: var(--link-color, #A89368); 
    }
    
    a:hover {
        text-decoration: underline;
        color: var(--link-color-hover, #A89368);
    }
  `;

  render() {
    return html`
      <h4>More Like This</h4>
      ${this.projects.length > 0 ? html`
        <div class="grid">
          ${this.projects.map(project => html`
            <project-element class="entry" project_id="${project.uuid}" project_name="${project.title}" .project_thumb=${project.item_thumb} user_id="${project.author_id}" username="${project.username}" profilename="${project.display_name}" staff="${project.is_staff}" patron="${project.paid_supporter}" verified="${project.verified_uploader}" nsfw="${project.adult_content}" furry="${project.furry_content}" showCollectionButton="${this.showCollectionButton}"></project-element>
          `)}
        </div>
      ` : html``}
      ${this.error !== '' ? html`
        <div>${this.error}</div>
      ` : html``}
    `;
  }
}

window.customElements.define('more-like-this', MoreLikeThis);